const STORE_KEY = 'spPlpData';

export function set(data){ 
    try {
        sessionStorage.setItem(STORE_KEY, JSON.stringify(data));
    } catch {
        return;
    }
} 

export function get(){
    try {
        return JSON.parse(sessionStorage.getItem(STORE_KEY));
    } catch {
        return null;
    }
}

